import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-rangeslider';
import 'react-rangeslider/lib/index.css';
import './SliderInput.css';

class SliderInput extends Component {
  static defaultProps = {
    value: 1,
    label: '',
    description: '',
    errorText: '',
    className: '',
  };
  constructor(props, context) {
    super(props, context);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(value) {
    // the library is in charge of transfering the data from dom to virtual dom.
    const { id, onChange, onValidate } = this.props;
    onChange(id, value);
    onValidate(id, value);
  }

  render() {
    const {
      id, name, label, value, description, errorText, className,
    } = this.props;
    // min max and step is hardcoded for now to suit tokenDecimal.
    // remove this when we fix the has for.
    /* eslint-disable jsx-a11y/label-has-for */
    return (
      <div className={`${className} slide`}>
        <label className="active" htmlFor={id}>
          {label}
        </label>
        <Slider
          min={0}
          max={18}
          step={1}
          value={value}
          onChange={this.handleChange}
          name={name}
          id={id}
        />
        <div className="value">{value}</div>
        {description !== '' ? <div className="field-description">{description}</div> : null}
        {errorText !== '' ? <div className="error-message">{errorText}</div> : null}
      </div>
    );
    /* eslint-enable jsx-a11y/label-has-for */
  }
}

SliderInput.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  value: PropTypes.number,
  description: PropTypes.string,
  errorText: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onValidate: PropTypes.func.isRequired,
};

export default SliderInput;



// WEBPACK FOOTER //
// ./src/components/formElements/SliderInput.js